export default {
  initRotaryTable: '/gw/generic/jrm/h5/m/initRotaryTable', // 初始化转盘
  bShenQLottery: '/gw/generic/jrm/h5/m/bShenQLottery', // 抽奖
  getBTotalAndUsedTimes: '/gw/generic/jrm/h5/m/getBTotalAndUsedTimes', // 总的和已使用的抽奖机会
  encodeBpin: '/gw/generic/jrm/h5/m/encodeBpin', // 分享前加密B端pin
  cHelpBAndLottery: '/gw/generic/jrm/h5/m/cHelpBAndLottery', // c端助力B端
  getHeadUrlByEnBPin: '/gw/generic/jrm/h5/m/getHeadUrlByEnBPin', // 根据加密pin获取b端头像链接
  getToDayHitRd: '/gw/generic/jrm/h5/m/getToDayHitRd', // 查询C端领奖页面信息
  cPickupReward: '/gw/generic/jrm/h5/m/cPickupReward', // C端领奖
  fromShareRedirect: '/gw/generic/jrm/redirect/m/fromShareRedirect', // 分享链接
  getLastHitRdListAndTotal: '/gw/generic/jrm/h5/m/getLastHitRdListAndTotal', // 最近中奖人及总抽奖人次
  sQShareSave: '/gw/generic/jrm/h5/m/sQShareSave', // 保存B端分享记录
  
}



// WEBPACK FOOTER //
// ./src/api/url.js